<div class="content">
  <div class="container">
    <div class="row header">
      <div class="image-col">
        <div class="nav__content">
          <div class="image">
            <img class="logo" src="/assets/images/logo.svg" alt="">
          </div>
        </div>
      </div>
    </div>
    <div class="row error">
      <h1 class="title"><em class="bi-calendar2-x-fill"></em> Page Not Found</h1>
    </div>
  </div>
</div>
